import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const TextBlock = makeShortcode("TextBlock");
const CodeBlock = makeShortcode("CodeBlock");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <TextBlock slots="heading, text, buttons" theme="dark" hasCodeBlock className='bgBlue code-block-button-padding' mdxType="TextBlock" />
    <h5 {...{
      "id": "pdf-analytics"
    }}>{`PDF ANALYTICS`}</h5>
    <p>{`Easily integrate Adobe Analytics with only a few steps, or leverage the user events to push data to other analytics tools`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/document-services/document-services/docs/overview/pdf-embed-api/howtodata/"
        }}>{`See documentation`}</a></li>
    </ul>
    <CodeBlock slots="heading, code" repeat="1" languages="JSON, CURL, JSON" mdxType="CodeBlock" />
    <h4 {...{
      "id": "javascript"
    }}>{`JavaScript`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`adobeDCView.registerCallback(
  /* Type of call back */
  AdobeDC.View.Enum.CallbackType.EVENT_LISTENER,
  /* call back function */
  function(event) {
    console.log(event);
  },
  { enablePDFAnalytics: true }
);
`}</code></pre>
    {/* <TextBlock slots="buttons"  theme="dark" className='bgBlue'/>
     - [Get free cretentials](/src/pages/gettingstarted.md) */}

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      